<div class="preloader" *ngIf="isLoading">
    <img class="preloader__image" width="60" src="assets/images/loader-2.png" alt="img" />
</div>
